<!-- <capture-image></capture-image> -->
<input type="file" />